class CompareProductPopup extends HTMLElement {
  constructor() {
    super();
    try {
      const stored = JSON.parse(localStorage.getItem("compareItem") || "[]");
      this.compareItems = Array.isArray(stored) ? stored.filter(x => typeof x === 'string' && /^[a-z0-9-]+$/i.test(x)) : [];
    } catch (_) { this.compareItems = []; }
    this.init();
  }

  init() {
    document.addEventListener("click", this.handleClick.bind(this));
    this.initCompareProduct();
    this.setupEventListeners();
    this.setLocalStorageProductForCompare();
  }

  getCompareDrawer() {
    return document.querySelector("#halo-compare-product-popup");
  }

  handleClick(event) {
    const target = event.target;
    if (target.matches("[data-compare-link]") || target.closest("[data-compare-link]")) {
      const opener = target.closest("[data-compare-link]");
      this.handleCompareLink(opener);
    } else if (target.closest("[data-compare-remove]")) {
      this.handleCompareRemove(target.closest("[data-compare-remove]"));
    }
  }

  initCompareProduct() {
    const closeBtn = document.querySelector(
      "[data-close-compare-product-popup]"
    );

    if (window.compare.show) {
      this.setLocalStorageProductForCompare();
      const drawer = this.getCompareDrawer();
      const hideComparePopup = () => drawer?.close?.();

      closeBtn?.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        hideComparePopup();
      });
    }
  }

  setupEventListeners() {
    document.addEventListener("change", (event) => {
      if (event.target.matches("[data-product-compare] input")) this.handleCompareChange(event);
    });
  }

  setLocalStorageProductForCompare() {
    const items = document.querySelectorAll("[data-product-compare-handle]");

    if (!this.compareItems) return;

    items.forEach((element) => {
      const handle = element.dataset.productCompareHandle;
      const compareIcon = element.querySelector(".compare-button");
      const text = element.querySelector(".text .text-inner");
      const input = element.querySelector("input");

      if (this.compareItems.includes(handle)) {
        compareIcon?.classList.add("is-checked");
        if (text) text.textContent = window.compare.added;
        if (input) input.checked = true;
      } else {
        compareIcon?.classList.remove("is-checked");
        if (text) text.textContent = window.compare.add;
        if (input) input.checked = false;
      }
    });

    this.updateCounterCompare();
  }

  handleCompareChange(event) {
    const target = event.target;
    const item = target.closest(".card-compare");
    const handle = target.value;

    if (target.checked) {
      item.querySelector(".compare-icon")?.classList.add("is-checked");
      item.querySelector(".text").textContent = window.compare.added;
      target.checked = true;
      target.closest(".compare-button").classList.add("is-checked");
      this.incrementCounterCompare(handle);
    } else {
      item.querySelector(".compare-icon")?.classList.remove("is-checked");
      item.querySelector(".text").textContent = window.compare.add;
      target.checked = false;
      target.closest(".compare-button").classList.remove("is-checked");
      this.decrementCounterCompare(handle);
    }
  }

  handleCompareLink(opener) {
    if (this.compareItems.length <= 1) {
      alert(window.compare.message);
      return false;
    }
    opener?.classList?.add('loading');
    opener?.querySelector('.loading__spinner')?.classList?.remove('hidden');
    this.updateContentCompareProduct(this.compareItems, 0, opener);
  }

  handleCompareRemove(target) {
    const id = target.dataset.compareItem;
    const compareTable = document.querySelector(
      "[data-compare-product-popup] .compareTable"
    );
    const item = compareTable.querySelector(
      `.compare-table-row[data-product-compare-id="${id}"]`
    );
    const handle = item?.dataset.compareProductHandle;
    const drawer = this.getCompareDrawer();

    if (compareTable.querySelectorAll("tbody .compare-table-row").length === 1) {
      item?.remove();
      this.decrementCounterCompare(handle);
      drawer?.close?.();
    } else {
      item?.remove();
      this.decrementCounterCompare(handle);
    }

    document.querySelectorAll(`[data-compare-handle="${handle}"]`).forEach(itemHandle => {
      itemHandle.classList.remove("is-checked");
      itemHandle.querySelector(".text").textContent = window.compare.add;
      itemHandle.querySelector("input[name='compare']").checked = false;
    });
  }

  updateCounterCompare() {
    const compareLink = document.querySelector("[data-compare-link]");
    if (!compareLink) return;

    if (this.compareItems.length > 1) {
      compareLink.parentElement.classList.add("is-show");
      compareLink.querySelector("span.countPill").textContent =
        this.compareItems.length;
    } else {
      compareLink.parentElement.classList.remove("is-show");
    }
  }

  incrementCounterCompare(item) {
    if (!this.compareItems.includes(item)) {
      this.compareItems.push(item);
      try { localStorage.setItem("compareItem", JSON.stringify(this.compareItems)); } catch (_) {}
      this.updateCounterCompare();
    }
  }

  decrementCounterCompare(item) {
    const index = this.compareItems.indexOf(item);
    if (index > -1) {
      this.compareItems.splice(index, 1);
      try { localStorage.setItem("compareItem", JSON.stringify(this.compareItems)); } catch (_) {}
      this.updateCounterCompare();
    }
  }

  async updateContentCompareProduct(list, count, opener) {
    const table = document.querySelector('[data-compare-product-popup] .compareTable');
    if (!table) return;
    const body = table.querySelector('tbody');
    const root = window.Shopify?.routes?.root || '/';
    body.replaceChildren();
    const message = (text) => {
      const row = document.createElement('tr');
      const cell = document.createElement('td'); cell.colSpan = 7; cell.textContent = text;
      row.append(cell); body.append(row);
    };
    let failures = 0;
    try {
      for (const handle of list) {
        try {
          const response = await fetch(`${root}products/${encodeURIComponent(handle)}?view=ajax_product_card_compare`);
          if (!response.ok) throw new Error('Unavailable product');
          const html = await response.text();
          const parsed = document.createElement('template');
          parsed.innerHTML = '<table><tbody>' + html + '</tbody></table>';
          const row = parsed.content.querySelector('tr[data-product-compare-id]');
          if (!row) throw new Error('Invalid comparison response');
          body.append(row);
        } catch (_) { failures++; }
      }
      if (failures) message('Some products could not be loaded. Close this comparison and try again.');
      if (!list.length) message('Choose at least two products to compare.');
      this.getCompareDrawer()?.open?.(opener);
    } finally {
      opener?.classList.remove('loading');
      opener?.querySelector('.loading__spinner')?.classList.add('hidden');
    }
  }
}
if (!customElements.get('compare-product-popup')) customElements.define('compare-product-popup', CompareProductPopup);
